import React from "react";
import {Box } from "@mui/material";

const Footer = () => {
  return (
    <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#F3EBCC",
          padding: { xs: 1, sm: 2 },
          textAlign: "center",
          fontSize: "0.6rem",
          zIndex: 1100, 
        }}
      >
        Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.
      </Box>
  );
};

export default Footer;
